import React from 'react';
import { Helmet } from 'react-helmet';
import Box from '@mui/material/Box';
import '../../Home.css';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import {Trans, withTranslation} from 'react-i18next';
import Link from '@mui/material/Link';

class About extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { props } = this;
        const { domain } = props;

        return (
            <>
                <Helmet>
                    <title>{this.props.t('about.metatitle', {
                        domain
                    })}</title>
                    <meta
                        name="description"
                        content={this.props.t('about.metadescription', {
                            domain
                        })}
                    />
                    <meta name="keywords" content={this.props.t('about.metakeywords', {
                        domain
                    })} />
                </Helmet>
                <Grid
                    container
                    spacing={2}
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                >
                    <Grid item xs={12} sm={12}>
                        <Box pt={'24px'} pb={'12px'}>
                            <Typography variant="h4" component="h1">
                                {this.props.t('about.heading', {
                                    domain
                                })}
                            </Typography>
                        </Box>
                        <Box pl={'2px'}>
                            <Typography variant="body1" component={'div'}>
                                <p>{domain === 'forecast.lv' ? this.props.t('about.body', {
                                    domain
                                }) : this.props.t('about.body_global', {
                                    domain
                                })
                                }</p>
                                <p>{this.props.t('about.body2', {
                                    domain
                                })}</p>
                                <h4><Trans i18nKey="about.heading2"></Trans></h4>
                            </Typography>
                            <Typography variant="body1" component={'div'}>
                                <p>{this.props.t('about.contact', {
                                    domain
                                })}</p>
                                <p><Trans i18nKey="about.contacus">
                                    По вопросам сотрудничества обращайтесь через контактную
                                    форму:
                                </Trans>{' '}
                                {domain === 'forecast.lv' &&
                                    <Link
                                        color="secondary"
                                        target="_blank"
                                        href="https://forms.gle/9cFPn1vp3gFNwYFa9"
                                    >
                                        https://forms.gle/9cFPn1vp3gFNwYFa9
                                    </Link>
                                }
                                {domain === 'weather5days.com' &&
                                    <Link
                                        color="secondary"
                                        target="_blank"
                                        href="https://forms.gle/qTstME7MeNjiiWeRA"
                                    >
                                        https://forms.gle/qTstME7MeNjiiWeRA
                                    </Link>
                                }</p>
                                <p>{this.props.t('about.contact2', {
                                    domain
                                })}</p>
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            </>
        );
    }
}

export default withTranslation('translations')(About);